import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from '../locale/en.json';
import ptTranslations from '../locale/pt.json';
import esTranslations from '../locale/es.json';

// Leitores de tela leem o idioma do <html>: fixo em "en", liam o português com sotaque inglês.
i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
});

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: enTranslations },
            pt: { translation: ptTranslations },
            es: { translation: esTranslations },
        },
        fallbackLng: 'en',
        detection: {
            order: ['navigator', 'localStorage', 'sessionStorage', 'cookie'],
            caches: ['localStorage', 'cookie'],
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
